import {Anchor} from "../core/Anchor";
import {Sprite} from "../core/Sprite";
import {Assets} from "../data/Assets";
import {AbstractGameState} from "./AbstractGameState";

export class PaperBackgroundState extends AbstractGameState {

    public readonly bg = this.addChild(new Sprite(Assets.paperBackground.getAsset(), Anchor.middleCenter));

    public onResize(pSize: PIXI.Point) {
        super.onResize(pSize);

        this.bg.width = this._size.x;
        this.bg.height = this._size.y;
    }
}
